import { render, staticRenderFns } from "./ChattingOverview.vue?vue&type=template&id=15a3cce6&scoped=true"
import script from "./ChattingOverview.vue?vue&type=script&lang=js"
export * from "./ChattingOverview.vue?vue&type=script&lang=js"
import style0 from "./ChattingOverview.vue?vue&type=style&index=0&id=15a3cce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3cce6",
  null
  
)

export default component.exports